// extracted by mini-css-extract-plugin
module.exports = {"navHeight":"52","brushSelectionColor":"#29abe0"};